import { useEffect } from 'react'

import { useAuthStateChange } from '@/modules/auth'
import { useAsyncError } from '@/modules/errors'
import {
  useFolder,
  useFoldersActions,
  useFoldersLoaders,
} from '@/modules/folders'
import { useDocumentsStore } from '../stores'

export const useLoadingDocuments = () =>
  useDocumentsStore((state) => state.loadingDocuments)

export const useDocumentsMutating = () =>
  useDocumentsStore((state) => state.mutating)

export const useDocuments = () => useDocumentsStore((state) => state.documents)

export const useDocumentsActions = () =>
  useDocumentsStore((state) => state.actions)

export const useDocumentsMutations = () =>
  useDocumentsStore((state) => state.mutations)

export const useDocumentsLoaders = () =>
  useDocumentsStore((state) => state.loaders)

export const useLoadingSearch = () =>
  useDocumentsStore((state) => state.loadingSearch)

export const useFetchDocuments = (folderSlug?: string) => {
  const folder = useFolder()
  const folderLoaders = useFoldersLoaders()
  const { reset: resetFolders, setFolder } = useFoldersActions()
  const loaders = useDocumentsLoaders()
  const { reset, startLoadingDocuments } = useDocumentsActions()
  const throwError = useAsyncError()

  useEffect(() => {
    if (folderSlug) {
      startLoadingDocuments()
      folderLoaders.fetchFolder(folderSlug).catch(throwError)
    } else {
      setFolder(null)
      folderLoaders.fetchFolders('document').catch(throwError)
      loaders.fetchDocuments().catch(throwError)
    }
  }, [])

  useEffect(() => {
    if (folderSlug && folder?.id) {
      loaders.fetchDocuments(folder.id).catch(throwError)
    }
  }, [folder])

  useAuthStateChange({
    onSignedOut: () => {
      reset()
      resetFolders()
    },
  })
}
